<template>
    <div class="pagosc">
        <Menu :url="url" :sesion="sesion" v-if="sesion"/>
        <Submenu :url="url" v-if="sesion"/>
        <PagosC :url="url" class="mt-5"/>
    </div>
</template>

<script>
import { globalFunctions } from '@/hooks/globalFunctions'
import Menu from '@/components/Menu'
import Submenu from '@/components/Submenu'
import PagosC from '@/components/PagosC'

export default {
name: 'Panel',
mixins: [ globalFunctions ],
components:{Menu,Submenu,PagosC},

data () {
    return {
        sesion: false,
    }
},
mounted(){
    let resp = this.checkUser();
    this.sesion = resp;
},
}
//Fin Script
</script>


// WEBPACK FOOTER //
// src/views/Pagos/Pagos.vue